export const ROOM_CONNECTION_STATE = {
    IDLE: "IDLE",
    CONNECTING: "CONNECTING",
    CONNECTED: "CONNECTED",
    REJECTED: "REJECTED",
    NOT_FOUND: "NOT_FOUND",
    ERROR: "ERROR",
    DISCONNECTED: "DISCONNECTED",
    FEEDBACK: "FEEDBACK"
};
